import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  SimpleChanges,
  ChangeDetectorRef,
} from '@angular/core';
import { MyProvider } from '@assets/services/provider';
import { IUserInfo, UserEntryPermission } from 'app/Models/interfaces/UserInfo';

@Component({
  selector: 'app-user-info-modal',
  templateUrl: './user-info-modal.html',
  styleUrls: ['./user-info-modal.scss'],
})
export class UserInfoModalComponent implements OnInit {
  public user: IUserInfo;
  public entryAtivities: UserEntryPermission;
  activities = [
    { key: 'A', label: 'Add' },
    { key: 'E', label: 'Edit' },
    { key: 'D', label: 'Delete' },
    // { key: 'L', label: 'Locate' },
    // { key: 'P', label: 'Print' },
    { key: 'O', label: 'Opening Balance' },
  ];
  modules: string[];
  @Input() visible: boolean = false;
  @Output() visibleChange = new EventEmitter<boolean>();

  constructor(private provider: MyProvider) {
    this.user = {
      userId: this.provider.companyinfo.userinfo?.user_id,
      userName: this.provider.companyinfo.userinfo?.username,
      userLongname: this.provider.companyinfo.userinfo?.userlongname,
      mobileno: this.provider.companyinfo.userinfo?.mobileNo,
      emailId: this.provider.companyinfo.userinfo?.mailAddress,
      isAdmin: this.provider.companyinfo.userinfo?.isAdmin,
    };
    this.entryAtivities = {
      userId: this.provider.companyinfo.userinfo?.user_id,
      A: this.provider.companyinfo.userinfo?.a,
      E: this.provider.companyinfo.userinfo?.e,
      D: this.provider.companyinfo.userinfo?.d,
      L: this.provider.companyinfo.userinfo?.l,
      P: this.provider.companyinfo.userinfo?.p,
      O: this.provider.companyinfo.userinfo?.o,
    };

    this.modules = this.provider.companyinfo.userinfo?.modules.map((x) => {
      return x.modulename;
    });
  }
  ngOnInit(): void {}

  closeModal() {
    this.visible = false;
    this.visibleChange.emit(this.visible);
  }
  trackByKey(index: number, item: any) {
    return item.key;
  }
}
